import { tns } from 'tiny-slider/src/tiny-slider';

export function initTinyCarousels(selector, optionsArray = [{}]) {
    const sliders = document.querySelectorAll(selector);
    if (!sliders.length) return;

    sliders.forEach((el, index) => {
        const opts = optionsArray[index] || optionsArray[0];

        const defaultResponsive = {
            0:    { items: 1 },
            576:  { items: 2 },
            768:  { items: 3 },
            992:  { items: 4 },
            1440: { items: 5 },
        };

        const baseConfig = {
            container: el,
            items: opts.itemPerRow || 5,
            gutter: opts.itemWidth || 20,
            autoplay: !!opts.autoplay,
            autoplayTimeout: opts.autoplay || 2500,
            controls: opts.controls !== false,
            nav: opts.nav !== false,
            loop: opts.loop !== false,
            mouseDrag: true,
            speed: opts.speed || 400,
            autoplayButtonOutput: false,
            responsive: opts.responsive || defaultResponsive,
        };

        const finalConfig = { ...baseConfig, ...opts };

        tns(finalConfig);
    });
}
